import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import { BASE_URL } from '../chartConstants';

const sdk = new ChartsEmbedSDK({
  baseUrl: BASE_URL,
});

const ChartEmbed = ({ chartId, height, filter }) => {
  const containerRef = useRef(null);
  const chartRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!containerRef.current || !chartId) return;
    const chart = sdk.createChart({
      chartId,
      height,
      autoRefresh: false,
      theme: 'dark',
      // Blend into the surrounding card instead of drawing its own panel.
      background: 'transparent',
      padding: 0,
      showAttribution: false,
    });
    chartRef.current = chart;
    chart
      .render(containerRef.current)
      .then(() => setReady(true))
      .catch((err) => console.log('Error during Charts rendering.', chartId, err));
    return () => {
      setReady(false);
      chartRef.current = null;
    };
  }, [chartId]);

  useEffect(() => {
    if (!ready || !chartRef.current) return;
    // Rejected when the field is missing from the chart's "Allow filtering by fields" list,
    // which leaves the chart on its own baked-in date range.
    chartRef.current
      .setFilter(filter || {})
      .catch((err) => console.log('Error during Charts filtering.', chartId, filter, err));
  }, [ready, JSON.stringify(filter, (_, v) => (v instanceof Date ? v.toISOString() : v))]);

  if (!chartId) {
    return (
      <div
        style={{ height, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888' }}
      >
        Chart not configured
      </div>
    );
  }

  return <div ref={containerRef} style={{ height, width: '100%' }} />;
};

ChartEmbed.propTypes = {
  chartId: PropTypes.string.isRequired,
  height: PropTypes.string,
  filter: PropTypes.object,
};

ChartEmbed.defaultProps = {
  height: '300px',
  filter: {},
};

export default ChartEmbed;
